import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, interval, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { SessionExpiredDialogComponent } from '../components/common/session-expired-dialog/session-expired-dialog.component';
import { jwtDecode } from 'jwt-decode';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly apiUrl = 'https://mevoz.net/soab';
  private sessionCheckSubscription: Subscription | null = null;

  constructor(private http: HttpClient, private router: Router, private dialog: MatDialog) { }

  register(user: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/register`, user);
  }

  login(email: string, password: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/login`, { email, password });
  }

  verifyEmail(email: string, verificationCode: string): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/email-verification`, { email, verificationCode });
  }



resendVerificationEmail(email: string): Observable<any> {
  return this.http.post<any>(`${this.apiUrl}/resend-email`, { email });
}


  // New Methods

  startSessionCheck() {
    // Check every 5 minutes
    this.sessionCheckSubscription = interval(10000).subscribe(() => {
      if (this.isTokenExpired()) {
        console.log('Session expired');
        this.showSessionExpiredDialog();
      }
    });
  }

  stopSessionCheck() {
    this.sessionCheckSubscription?.unsubscribe();
    this.sessionCheckSubscription = null;
  }

  private isTokenExpired(): boolean {
    const token = localStorage.getItem('token');
    if (!token) {
      return false; // No token means the user is not logged in; hence, the session can't be expired.
    }
  
    try {
      const decoded: any = jwtDecode(token); // Ensure you're using the correct method to decode the JWT. It might be `jwtDecode` based on your imports.
      const currentTime = Date.now() / 1000; // Current time in seconds
      if (decoded.exp < currentTime) {
        // Token is expired
        return true;
      }
    } catch (error) {
      console.error('Error decoding token:', error);
      return false; // Assume the token is invalid if it can't be decoded
    }
  
    return false; // Token exists and is not expired
  }
  

  private showSessionExpiredDialog(): void {
    this.dialog.open(SessionExpiredDialogComponent, {
      width: '300px',
      disableClose: true
    }).afterClosed().subscribe(() => {
      this.logout();
    });
  }

  logout() {
    localStorage.removeItem('token'); // Clear token from storage
    this.stopSessionCheck(); // Ensure the check is stopped on logout
    this.router.navigate(['/login']);
  }


  isLoggedIn(): boolean {
    const token = localStorage.getItem('token');
    if (!token) {
      return false;
    }

    try {
      const decoded: any = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      return decoded.exp > currentTime;
    } catch (error) {
      console.error('Error decoding token:', error);
      return false;
    }
  }

  forgotPassword(email: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/forgot-password`, { email });
  }

  changePassword(currentPassword: string, newPassword: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/change-password`, { currentPassword, newPassword });
  }
}
